import { FloatingColumn } from './styles'

export default FloatingColumn
